import React from 'react';
import SelectSource, {
  SelectSourceSection,
} from '../../../components/select-source/SelectSource';
import {Box, Typography} from '@mui/material';

const sections: SelectSourceSection[] = [
  {
    id: 'security-groups',
    label: 'Security Groups',
    type: 'tree',
    treeData: {
      itemsList: [
        {id: 'sg1', label: 'Admin', fileType: ''},
        {id: 'sg2', label: 'User', fileType: ''},
      ],
      props: {},
    },
  },
  {
    id: 'searches',
    label: 'Searches',
    type: 'tree',
    treeData: {
      itemsList: [
        {
          id: 's1',
          label: 'Recent',
          fileType: '',
          children: [
            {
              id: 's1a',
              label: 'Recent A',
              fileType: '',
              children: [
                {id: 's1a1', label: 'Recent A1', fileType: ''},
                {id: 's1a2', label: 'Recent A2', fileType: ''},
              ],
            },
            {
              id: 's1b',
              label: 'Recent B',
              fileType: '',
              children: [{id: 's1b1', label: 'Recent B1', fileType: ''}],
            },
          ],
        },
        {
          id: 's2',
          label: 'Saved',
          fileType: '',
          children: [
            {
              id: 's2a',
              label: 'Saved A',
              fileType: '',
              children: [{id: 's2a1', label: 'Saved A1', fileType: ''}],
            },
          ],
        },
      ],
      props: {},
    },
  },
  {
    id: 'projects',
    label: 'Projects',
    type: 'dropdown',
    dropdownData: {
      dropdownLabel: 'Projects',
      dropdownItems: [
        {id: 'p1', name: 'Project Alpha'},
        {id: 'p2', name: 'Project Beta'},
      ],
      selectedValues: null,
      onSelectionChange: () => {},
    },
  },
  {
    id: 'folders',
    label: 'Folders',
    type: 'tree',
    treeData: {
      itemsList: [
        {
          id: 'f1',
          label: 'Root',
          fileType: '',
          children: [
            {
              id: 'f1a',
              label: 'Subfolder A',
              fileType: '',
              children: [
                {id: 'f1a1', label: 'Subfolder A1', fileType: ''},
                {id: 'f1a2', label: 'Subfolder A2', fileType: ''},
              ],
            },
            {
              id: 'f1b',
              label: 'Subfolder B',
              fileType: '',
              children: [{id: 'f1b1', label: 'Subfolder B1', fileType: ''}],
            },
          ],
        },
        {
          id: 'f2',
          label: 'Archive',
          fileType: '',
          children: [
            {
              id: 'f2a',
              label: 'Old',
              fileType: '',
              children: [{id: 'f2a1', label: 'Old A1', fileType: ''}],
            },
          ],
        },
      ],
      props: {},
    },
  },
];

const handleSaveSelection = (sectionId: string, selection: any) => {
  alert(`Saved selection for ${sectionId}: ${JSON.stringify(selection)}`);
};

const SelectSourceDemo: React.FC = () => {
  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        ArrSelectSource Demo
      </Typography>
      <SelectSource sections={sections} onSaveSelection={handleSaveSelection} />
    </Box>
  );
};

export default SelectSourceDemo;
